// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ThankYouRegister_componentWrapper__J5EmF","actions":"ThankYouRegister_actions__yowA-"};